import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function candidateSubscriptionPayment(
  candidatePaymentData: object
): Promise<ApiResponse> {
  return Axios.post(
    "v1/subscriptions/candidate_subscription",
    candidatePaymentData
  );
}
export function candidateProgramPayment(
  candidatePaymentData: object
): Promise<ApiResponse> {
  return Axios.post(
    "v1/subscriptions/program_subscription",
    candidatePaymentData
  );
}
export function getCandidatePaymentDetails(
  id: string | number
): Promise<ApiResponse> {
  return Axios.get("v1/subscriptions/", id);
}

export function IndexCandidatePayments(): Promise<ApiResponse> {
  return Axios.get("v1/subscriptions/");
}
